export default __webpack_public_path__ + "static/media/31t.4f420075.jpg";